const VALID_TIERS: ReadonlySet<string> = new Set(['bronze', 'silver', 'gold', 'platinum'])

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

/**
 * Validates that a Lab remote-config payload is a well-formed LEBT société campaign config.
 * Based on `src/loyalty/tierUpgradeCampaign/tierUpgradeCampaignTypes.ts` in www-le-customer.
 * Renamed to match LEBT's société campaign feature.
 */
export function isLabLEBTSocieteCampaignPayload(
  payload: unknown,
): payload is App.SocieteCampaignPayload {
  if (!isObject(payload)) return false
  return (
    typeof payload.slug === 'string' &&
    Array.isArray(payload.tiers) &&
    payload.tiers.length > 0 &&
    payload.tiers.every((tier: unknown) => typeof tier === 'string' && VALID_TIERS.has(tier)) &&
    isObject(payload.hero) &&
    typeof payload.hero.title === 'string' &&
    (payload.hero.titleHighlight === undefined || typeof payload.hero.titleHighlight === 'string') &&
    typeof payload.hero.subtitle === 'string' &&
    typeof payload.hero.imageId === 'string' &&
    (payload.campaignId === undefined || typeof payload.campaignId === 'string') &&
    (payload.termsSlug === undefined || typeof payload.termsSlug === 'string') &&
    (payload.partner === undefined || (
      isObject(payload.partner) &&
      typeof payload.partner.name === 'string' &&
      typeof payload.partner.memberStatus === 'string' &&
      typeof payload.partner.logoImageId === 'string'
    )) &&
    (payload.secondarySection === undefined || (
      isObject(payload.secondarySection) &&
      typeof payload.secondarySection.title === 'string' &&
      typeof payload.secondarySection.subtitle === 'string'
    )) &&
    isObject(payload.notification) &&
    isObject(payload.notification.almostThere) &&
    typeof payload.notification.almostThere.title === 'string' &&
    typeof payload.notification.almostThere.subtitle === 'string' &&
    typeof payload.notification.almostThere.secondarySubtitle === 'string' &&
    isObject(payload.notification.unlock) &&
    typeof payload.notification.unlock.title === 'string' &&
    typeof payload.notification.unlock.subtitle === 'string' &&
    isObject(payload.notification.completion) &&
    typeof payload.notification.completion.title === 'string' &&
    typeof payload.notification.completion.subtitle === 'string' &&
    typeof payload.notification.completion.secondarySubtitle === 'string'
  )
}
